import { Loader as LoaderUI } from "semantic-ui-react";
import PropTypes from "prop-types";
import React from "react";

export const LoaderLine = ({ className, ...rest }) => (
	<div className={`loader-line ${className}`}>
		<LoaderUI active {...rest} />
	</div>
);

LoaderLine.propTypes = {
	className: PropTypes.string
};

LoaderLine.defaultProps = {
	className: ""
};

const Loader = () => (
	<div className="loader-block">
		<LoaderUI active />
	</div>
);

export default Loader;
